import { render, staticRenderFns } from "./SSelectListSuppliesNew.vue?vue&type=template&id=3d9d5e60"
import script from "./SSelectListSuppliesNew.vue?vue&type=script&lang=js"
export * from "./SSelectListSuppliesNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports